import React, { useState } from "react";
import Icon from '@ant-design/icons'
import { useFormik } from 'formik';

//Internal Components
import styles from './Login.module.css';
import TextBorderLess from "../../../common/components/TextBorderLess/TextBorderLess";
import allIcons from "../../../common/constants/svgIcon";
import LoadingButton from "../../../common/components/LoadingButton/LoadingButton";
import { COLORS } from "../../../common/constants/colors";
import Paint from "../../../common/components/Paint/Paint";
import { useAuth } from "../../../contexts/auth";
import { getError, openNotification, tryCatch } from "../../../common/constants/Utilities";
import axios from "axios";
import { IUser } from "../../../interfaces/IUser";
import { useNavigate } from "react-router-dom";

interface User {
    username: string;
    accessCode: string;
}

const Login: React.FC = () => {
    const navigate = useNavigate();
    // States
    const [generalError, setGeneralError] = useState<string | null>();
    const { signIn, user } = useAuth();
    const [loading, setLoading] = useState<boolean>(false);

    // Validations
    const validations = (values: User) => {
        const errors: any = {};
        if (!values.username) {
            errors.username = 'Requerido';
        }

        if (!values.accessCode) {
            errors.accessCode = 'Requerido';
        }

        return errors;
    };


    const handleLogin = (userParam: string, passParam: string) => {
        setLoading(true);
        setGeneralError(null);
        tryCatch(() => {
            signIn(userParam, passParam)
                .then((response) => {
                    openNotification('success', `Bienvenido`, response.msg!);
                })
                .catch((error) => {
                    setGeneralError(getError(error));
                })
                .finally(() => {
                    setLoading(false);
                    navigate("Principal");
                })
        })
    }

    // Form
    const loginForm = useFormik({
        initialValues: { username: '', accessCode: '' },
        validate: validations,
        onSubmit: (values: User) => handleLogin(values.username.toLowerCase(), values.accessCode)
    });


    return (
        <div className={styles.container}>
            <div className={styles.card}>

                {/* Descripcion de la app*/}
                <div className={styles.group1}>
                    <div className={styles.background_style}>
                        <div className={styles.presentation}>
                            <div className={styles.group1_content}>
                                <div className={styles.image}> </div>
                                <p className={styles.app_description}>
                                    <Paint color={COLORS.blue_active}>BisFormularios </Paint>
                                    es una aplicación multiplataforma enfocada en la automatización y sistematización de los procesos de todo tipo de encuestas
                                    <Paint color={COLORS.blue_active}> ©CopyRight 2022 CND-BIS</Paint>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Controles para iniciar session */}
                <div className={styles.group2}>
                    <div className={styles.formulario}>
                        <div className={styles.logo}></div>
                        <div className={styles.group2_content}>
                            <div>
                                <TextBorderLess
                                    value={loginForm.values.username}
                                    onChange={loginForm.handleChange}
                                    props={{ type: "text" }}
                                    name={"username"}
                                    active={!loading}
                                    placeholder="Usuario"
                                    Icon={<Icon component={allIcons.UserIcon} />}
                                />
                                <p className={styles.error}>
                                    <Paint color={COLORS.red_error1}>{loginForm.errors.username && loginForm.errors.username}</Paint>
                                </p>
                            </div>
                            <div className={styles.margin_input}>
                                <TextBorderLess
                                    value={loginForm.values.accessCode}
                                    onChange={loginForm.handleChange}
                                    props={{ type: "password" }}
                                    name={"accessCode"}
                                    active={!loading}
                                    placeholder="Contraseña"
                                    Icon={<Icon component={allIcons.LockIcon} />}
                                />
                                
                                <p className={styles.error}>
                                    <Paint color={COLORS.red_error1}>{loginForm.errors.accessCode && loginForm.errors.accessCode}</Paint>
                                </p>
                            </div>
                            <div className={styles.margin_input}>
                                <LoadingButton
                                    type="button"
                                    disabled={loading ? true : false}
                                    method={loginForm.handleSubmit}
                                    title={"Iniciar Sesión"}
                                    loading={loading.toString()}
                                    background={COLORS.white_color1}
                                    color={COLORS.blue_active}
                                    fontsize={18}
                                />
                            </div>

                            {!!generalError && (
                                <p className={styles.generalError}>
                                    <Paint color={COLORS.red_error1}>{generalError}</Paint>
                                </p>
                            )}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}


export default Login;